(() => {
  const alpineRoots = (section) => {
    const roots = Array.from(section.querySelectorAll('[x-data]'));
    if (section.matches('[x-data]')) roots.unshift(section);
    return roots;
  };

  const reinitializeSection = (event) => {
    const section = event.target;
    if (!(section instanceof Element)) return;

    window.requestAnimationFrame(() => {
      const roots = alpineRoots(section);
      const needsAlpineInitialization = roots.some((root) => !root._x_dataStack);

      if (
        needsAlpineInitialization &&
        window.Alpine &&
        typeof window.Alpine.initTree === 'function'
      ) {
        window.Alpine.initTree(section);
      }

      window.dispatchEvent(new CustomEvent('bohemia:section:load', {
        detail: {
          section,
          sectionId: event.detail?.sectionId || section.dataset.sectionId || null
        }
      }));
    });
  };

  document.addEventListener('shopify:section:load', reinitializeSection);
  document.addEventListener('shopify:section:unload', (event) => {
    window.dispatchEvent(new CustomEvent('bohemia:section:unload', {
      detail: {
        section: event.target,
        sectionId: event.detail?.sectionId || null
      }
    }));
  });
})();
